import React, { Component } from "react";


import LoginFormComponent from "../components/LoginFormComponent";
import Utils from "../../Utils";
import { getUserProfile } from "../services/AuthService";




class LoginPage extends Component {


 loginSuccessCallback = async (json) => {


   try {


     console.log("LOGIN SUCCESS:", json);


     const payload = json?.data?.payload;


     if (!payload?.authToken) {
       console.error("Auth token not found");
       return;
     }


     const authToken = payload.authToken;


     console.log("AUTH TOKEN:", authToken);




     // -------------------------------------------------
     // Save authentication
     // -------------------------------------------------


     Utils.setAuthToken(authToken);
     Utils.setUser(payload);
     Utils.setLoginTime(new Date());




     // -------------------------------------------------
     // Get user profile
     // -------------------------------------------------


     console.log("Calling getUserProfile...");


     const response = await getUserProfile(authToken);


     console.log("getUserProfile response:", response);




     const userProfileDetails =
       response?.payload?.userProfileDetails;




     if (!userProfileDetails) {


       console.error(
         "User profile details not found:",
         response
       );


       return;
     }




     const {
       _id: userId,
       adminFirstName,
       adminLastName,
       wallet,
       sapFormatForOrderProcessing,
       depotName,
     } = userProfileDetails;




     // -------------------------------------------------
     // Save user profile
     // -------------------------------------------------


     if (userId) {


       Utils.setUserDetails({


         id: userId,


         userName:
           `${adminFirstName || ""} ${adminLastName || ""}`.trim(),


         walletToken:
           wallet?.walletToken || null,


         sapFormatForOrderProcessing,


         depotName,


       });


     }




     console.log("User profile saved");


     console.log(
       "Current history:",
       this.props.history
     );




     // -------------------------------------------------
     // REDIRECT
     // -------------------------------------------------


     console.log("Redirecting to dashboard...");


     this.props.history.replace("/");




   } catch (error) {


     console.error(
       "Login/profile error:",
       error
     );


     Utils.logoutUser();


   }


 };




 componentDidMount() {


   // Do not call logout repeatedly during rendering.
   Utils.logoutUser();


 }




 render() {


   return (


     <LoginFormComponent


       successCallback={
         this.loginSuccessCallback
       }


       failureCallback={() => {}}


     />


   );


 }


}




export default LoginPage;

